const pageSizes: number[] = [10, 20, 30, 40, 50, 100, 200];
const layout: string = "total, sizes, prev, pager, next, jumper";
const pagnition: any = { pageSizes: pageSizes, layout: layout };

export { pagnition };
